import { render, staticRenderFns } from "./MessageReadBlock.vue?vue&type=template&id=0a279ba4&scoped=true&"
import script from "./MessageReadBlock.vue?vue&type=script&lang=ts&"
export * from "./MessageReadBlock.vue?vue&type=script&lang=ts&"
import style0 from "./MessageReadBlock.vue?vue&type=style&index=0&id=0a279ba4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a279ba4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFadeTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFadeTransition,VFlex,VLayout})
